'use strict';

var Sugar = require('sugar-core'),
    arrayCount = require('../enumerable/internal/arrayCount'),
    fixArgumentLength = require('../common/internal/fixArgumentLength');

Sugar.Array.defineInstance({

  'count': fixArgumentLength(arrayCount)

});

module.exports = Sugar.Array.count;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/array/count.js
// module id = 1333
// module chunks = 0